module.exports = __webpack_public_path__ + "static/assets/c250cccf174a787bcf391c9123e82350.png";